export const LOAD_PRELIMINARY_EQUIPMENTS =
  'PreliminaryEquipments/LOAD_PRELIMINARY_EQUIPMENTS';
export const LOAD_PRELIMINARY_EQUIPMENTS_BY_RACE =
  'PreliminaryEquipments/LOAD_PRELIMINARY_EQUIPMENTS_BY_RACE';
export const NAMESPACE = 'PreliminaryEquipments';
